import styled from '@emotion/styled';

export const Logo = styled.div`
  align-self: center;
  height: 38px;
`;

export const UserName = styled.div`
  align-self: center;
`;

export const AppNavHolder = styled.div`
  display: flex;
  justify-content: start;
  align-self: start;
`;
